<template>
  <div class="tab_box">
    <Tabs value="incomplete" :animated="false" class="record-warper">
      <!-- 未使用 -->
      <TabPane label="未使用" name="incomplete" class="incomplete">
        <div class="item" v-for="item in incompleteData" :key="item._id">
          <span>￥{{ item.minus_price }}</span>
          <div class="info">
            <p class="user_type">{{ item.user_type }}专享</p>
            <p class="discount_name">{{ item.discount_name }}</p>
            <p class="time">{{ item.use_end_date }} 前有效</p>
          </div>
          <Button type="primary" @click="goUse">去使用</Button>
        </div>
      </TabPane>

      <!-- 已完成 -->
      <TabPane label="已使用" name="complete">
        <div class="item" v-for="item in completeData" :key="item._id">
          <span>￥{{ item.minus_price }}</span>
          <div class="info">
            <p class="user_type">{{ item.user_type }}专享</p>
            <p class="discount_name">{{ item.discount_name }}</p>
            <p class="time">{{ item.use_end_date }} 前有效</p>
          </div>
          <Button class="disabled" type="primary">已使用</Button>
        </div>
      </TabPane>

      <!--  过期页-->
      <TabPane label="已过期" name="expire" class="expire">
        <div class="item" v-for="item in expireData" :key="item._id">
          <span>￥{{ item.minus_price }}</span>
          <div class="info">
            <p class="user_type">{{ item.user_type }}专享</p>
            <p class="discount_name">{{ item.discount_name }}</p>
            <p class="time">{{ item.use_end_date }} 前有效</p>
          </div>
          <Button class="disabled" type="primary">已过期</Button>
        </div>
      </TabPane>
    </Tabs>
  </div>
</template>

<script>
import doPost from "@/pages/Helper/XHR.js";
export default {
  data() {
    return {
      completeData: [], //完成页得数据
      incompleteData: [], //未完成页的数据
      expireData: [], //过期页的数据
    };
  },
  created() {
    console.log("===进来额");
    this.getOrderInfo();
  },
  methods: {
    getOrderInfo() {
      if(!localStorage.getItem("username")){
        this.$Message.warning("登录已过期，即将重新登陆");
        setTimeout(()=>{
            this.$emit('loginout');
        }, 1500);
      }
      doPost(
        {
          action: "coupon_use_list",
          // session_str: localStorage.getItem("session_str"),
          user: localStorage.getItem("username"),
        },
        (res) => {
          //2020-10-20 修改逻辑
          if (!res.status && !res.ilst) {
            //先初始话三页的数据
            this.completeData = [];
            this.incompleteData = [];
            this.expireData = [];

            res.list.forEach((item, index) => {
              if (item.use_status == "3") {
                this.expireData.push(item);
              } else if (item.use_status == "1") {
                this.incompleteData.push(item);
              } else if (item.use_status == "2") {
                this.completeData.push(item);
              }
            });
          }
        }
      );
    },

    //去使用
    goUse() {
      window.open("/buy/");
    },
  },
};
</script>

<style lang="stylus" scoped>
.tab_box {
  width: 100%;
  overflow: hidden;
}

>>>.ivu-tabs-content {
  height: 385px;
  width: 100%;
  overflow: auto;
}

.item {
  width: 400px;
  height: 70px;
  background-color: #fecbbe;
  color: black;
  border-radius: 10px;
  position: relative;
  margin-bottom: 20px;
}

.item>span {
  display: inline-block;
  font-weight: bold;
  color: red;
  font-size: 16px;
  padding: 10px;
  vertical-align: middle;
  margin-top: -43px;
}

.item .info {
  display: inline-block;
  color: red;
  line-height: 22px;
  padding-top: 3px;
}

.item >>>.ivu-btn-primary {
  position: absolute;
  right: 20px;
  top: 20px;
  border-radius: 18px;
  background-color: #fff;
  border: 1px solid red;
  color: red;
  font-size: 14px;
}

.item >>>.ivu-btn-primary.disabled {
  border: 1px solid #999;
  background-color: #ccc;
  color: #999;
}

@media screen and (max-width: 800px) {
  .item {
    width auto
  }
  .item >>>.ivu-btn-primary {
    right 4px
  }
}
</style>


// WEBPACK FOOTER //
// src/pages/Personal/components/couponList.vue